/* eslint-disable no-underscore-dangle */

import { upperFirst } from 'lodash-es';

/**
 * Create dynamic variable name for loading with corresponding methods
 *
 * Example: if we pass `loading`, then it will create:
 *
 * variable: `isLoading`
 *
 * methods: `startLoading`, `stopLoading`, `executeProcessWithLoading`
 */
export default (varName) => {
  const upperFirstVarName = upperFirst(varName);

  const loadingName = `is${upperFirstVarName}`;
  const startLoadingFnName = `start${upperFirstVarName}`;
  const endLoadingFnName = `end${upperFirstVarName}`;
  const executeProcessWithLoadingFnName = `executeProcessWith${upperFirstVarName}`;

  return {
    data: () => ({
      [loadingName]: false,
    }),
    methods: {
      [startLoadingFnName]() {
        this[loadingName] = true;
      },
      [endLoadingFnName]() {
        this[loadingName] = false;
      },
      // we can use arrow function to execute more than one function
      async [executeProcessWithLoadingFnName](fn) {
        this[startLoadingFnName]();

        try {
          await fn();
        } finally {
          this[endLoadingFnName]();
        }
      },
    },
  };
};
